import { GM_LEVEL } from '../../../../shared/constants/GMPermissions';

/** Presentation gate only; the server still validates every gameplay request. */
export function canAuthorAbilities(hostname: string, gmLevel: number | undefined): boolean {
  return ['localhost', '127.0.0.1'].includes(hostname) || (gmLevel ?? 0) >= GM_LEVEL.GM_LOW;
}
